
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 2a6 6 0 100 12A6 6 0 008 2zM.667 8a7.333 7.333 0 1114.666 0A7.333 7.333 0 01.667 8z","fill":"#9B9FA9"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 3.333c.368 0 .667.299.667.667v3.588l2.298 1.149a.667.667 0 01-.597 1.193L7.702 8.596A.667.667 0 017.333 8V4c0-.368.299-.667.667-.667z","fill":"#9B9FA9"}})])
          )
        }
      }
    